import { IconMail } from "@tabler/icons-react";
import React, { useContext } from "react";
import { ThemeContext } from "@/theme/ThemeProvider";
import SettingTitle from "../SettingTitle";
import IdentifyVerification from "./IdentifyVerification";
import { AuditSettingContainer, AuditSettingSection } from "./styles";
import styled from "styled-components";
import { t } from "i18next";

const AuditSetting = () => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const levelOne = [
    {
      level: 1,
      title: t("successfullyRegistered"),
      icon: <IconMail color={textw} size={18} />,
    },
  ];
  const levelTwo = [
    {
      level: 2,
      title: t("idAndAuthenticationPhoto"),
      icon: <IconMail color={textw} size={18} />,
    },
  ];
  // const levelThree = [
  //   {
  //     level: 2,
  //     title: "selfie",
  //     icon: <IconMail color={textw} size={18} />,
  //   },
  // ];


  return (
    <AuditSettingSection>
      <SettingTitle title={t('audit')} />
      <AuditDesc>
        <ColorText>{t('WhatisKYC')}</ColorText>
        <p/>{t('AuditDesc1')}
        <p/>{t('AuditDesc2')}
      </AuditDesc>
      <AuditSettingContainer>
        <IdentifyVerification title={"beginner"} level={levelOne} />
        {/* <IdentifyVerification title={"basic"} level={levelTwo} /> */}
        <IdentifyVerification
          title={"basic"}
          level={levelTwo}
          last={true}
        />
      </AuditSettingContainer>
    </AuditSettingSection>
  );
};

export default AuditSetting;

const AuditDesc = styled.p`
    font-family: "Pretendard", sans-serif;
    font-weight: 500;
    font-size: 21px;
    white-space: pre-wrap;
    color: ${({ theme }) => theme.text};
    margin-top: 20px;
    margin-bottom: 60px;
    width: 80%;
    line-height: 1.3;
`

const ColorText = styled.span`
    color: ${({ theme }) => theme.primary};
`